import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const SearchListIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66602 6.83398H4.33268"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 10.166H4.33268"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 13.5H12.3327"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3563 9.19033L14.3327 11.1667M13.3327 6.83333C13.3327 4.99239 11.8403 3.5 9.99935 3.5C8.15842 3.5 6.66602 4.99239 6.66602 6.83333C6.66602 8.67427 8.15842 10.1667 9.99935 10.1667C11.8403 10.1667 13.3327 8.67427 13.3327 6.83333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
